import { render, staticRenderFns } from "./FragmentsEditorDialog.vue?vue&type=template&id=9372fcec"
import script from "./FragmentsEditorDialog.vue?vue&type=script&lang=ts"
export * from "./FragmentsEditorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports